import React, { useState } from 'react';
import { Menu, X, Linkedin, Mail } from 'lucide-react';
import { Button } from './ui/Button';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Our Work',
    href: '#work'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <div className="min-h-screen flex flex-col bg-stone-50" data-id="element-1">
      {/* Navigation */}
      <header className="sticky top-0 z-50 w-full border-b border-stone-200 bg-white/80 backdrop-blur-md" data-id="element-2">
        <div className="container mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-3">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2" data-id="element-4">
            <div className="w-9 h-9 bg-slate-900 rounded-lg flex items-center justify-center border border-slate-700 shadow-sm" data-id="element-5">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-6">
                <rect x="2" y="2" width="4" height="16" rx="1" fill="#f59e0b" data-id="element-7" />
                <rect x="14" y="2" width="4" height="16" rx="1" fill="#f59e0b" data-id="element-8" />
                <rect x="6" y="8.5" width="8" height="3" rx="0.5" fill="#fbbf24" data-id="element-9" />
              </svg>
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900" data-id="element-10">
              HBR <span className="text-slate-500 font-normal" data-id="element-11">Company</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-12">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-13">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" onClick={() => window.location.href = '#contact'} data-id="element-14">
              Get in Touch
            </Button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-15">
            {isMobileMenuOpen ? <X size={24} data-id="element-16" /> : <Menu size={24} data-id="element-17" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isMobileMenuOpen && <div className="md:hidden border-t border-stone-200 bg-white px-4 py-6 space-y-4 shadow-lg absolute w-full" data-id="element-18">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block text-base font-medium text-slate-600 hover:text-slate-900 py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-19">
                {link.name}
              </a>)}
            <Button className="w-full mt-4" onClick={() => {
          window.location.href = '#contact';
          setIsMobileMenuOpen(false);
        }} data-id="element-20">
              Get in Touch
            </Button>
          </div>}
      </header>

      {/* Main Content */}
      <main className="flex-1" data-id="element-21">{children}</main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800" data-id="element-22">
        <div className="container mx-auto px-4 md:px-6" data-id="element-23">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-24">
            <div className="col-span-1 md:col-span-2" data-id="element-25">
              <div className="flex items-center gap-2 mb-4" data-id="element-26">
                <div className="w-9 h-9 bg-slate-800 rounded-lg flex items-center justify-center border border-slate-600" data-id="element-27">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-28">
                    <rect x="2" y="2" width="4" height="16" rx="1" fill="#f59e0b" data-id="element-29" />
                    <rect x="14" y="2" width="4" height="16" rx="1" fill="#f59e0b" data-id="element-30" />
                    <rect x="6" y="8.5" width="8" height="3" rx="0.5" fill="#fbbf24" data-id="element-31" />
                  </svg>
                </div>
                <span className="font-bold text-xl tracking-tight text-white" data-id="element-32">
                  HBR{' '}
                  <span className="text-slate-400 font-normal" data-id="element-33">Company</span>
                </span>
              </div>
              <p className="text-slate-400 max-w-sm" data-id="element-34">
                Built by infrastructure. Built for business. Providing expert
                consulting in infrastructure, strategy, and digital presence.
              </p>
            </div>

            <div data-id="element-35">
              <h3 className="font-semibold text-white mb-4" data-id="element-36">Services</h3>
              <ul className="space-y-2 text-sm" data-id="element-37">
                <li data-id="element-38">
                  <a href="#services" className="hover:text-amber-500 transition-colors" data-id="element-39">
                    Infrastructure Consulting
                  </a>
                </li>
                <li data-id="element-40">
                  <a href="#services" className="hover:text-amber-500 transition-colors" data-id="element-41">
                    Project Management
                  </a>
                </li>
                <li data-id="element-42">
                  <a href="#services" className="hover:text-amber-500 transition-colors" data-id="element-43">
                    Business Strategy
                  </a>
                </li>
                <li data-id="element-44">
                  <a href="#services" className="hover:text-amber-500 transition-colors" data-id="element-45">
                    Digital Presence
                  </a>
                </li>
              </ul>
            </div>

            <div data-id="element-46">
              <h3 className="font-semibold text-white mb-4" data-id="element-47">Connect</h3>
              <div className="flex gap-4" data-id="element-48">
                <a href="https://www.linkedin.com/in/travishellstrom" target="_blank" rel="noopener noreferrer" className="hover:text-amber-500 transition-colors" aria-label="LinkedIn" data-id="element-49">
                  <Linkedin size={20} data-id="element-50" />
                </a>
                <a href="mailto:hello@hbr-company.com" className="hover:text-amber-500 transition-colors" aria-label="Email" data-id="element-51">
                  <Mail size={20} data-id="element-52" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500" data-id="element-53">
            <p data-id="element-54">&copy; 2026 HBR Company. All rights reserved.</p>
            <div className="flex gap-6 mt-4 md:mt-0" data-id="element-55">
              <a href="#" className="hover:text-slate-300" data-id="element-56">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-slate-300" data-id="element-57">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}